import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Tooltip,
  Button,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import { post } from "../../../helpers/api_helper";
import { errorMessage, successMessage } from "../CommonFunctions";
import {
  POST_DDLGetInwardsNoByCustomerID,
  POST_GetCourierDDLList,
  POST_GetCustomerDDLList,
  POST_GetCustomerProjectAddressDDLList,
  POST_GetCustomerProjectContactPersonDDLList,
  POST_GetCustomerProjectList,
  POST_GetEmployeeDDLList,
  POST_GetMaterialInwardDetailByID,
  POST_GetReportDispatchDetailByID,
  POST_GetReportDispatchInwardNoClubing,
  POST_GetReportDispatchTCNoDDLList,
  POST_GetReportDispatchTestNameByInwardMaterialID,
  POST_GetVoucherSeriesDDLList,
  POST_InsertReportDispatch,
  POST_ReportDispatchPrint,
  POST_UpdateReportDispatch,
} from "../../../helpers/url_helper";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
import moment from "moment";
import { color } from "echarts";

const AddReportDispatch = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { InwardIDParam, InwardMaterialIDParam } = useParams();
  const { PrimaryIdParam } = useParams();

  const [customerOptions, setCustomerList] = useState([]);
  const [courierOptions, setCourierList] = useState([]);
  const [inwardNoOptions, setInwardNoOptions] = useState([]);
  const [reportDispatchNoOptions, setReportDispatchNoOptions] = useState([]);
  const [tCNosOptions, setTCNosOptionsOptions] = useState([]);
  const [customerProjectOptions, setCustomerProjectOptions] = useState([]);
  const [reportingToOptions, setReportingToOptions] = useState([]);
  const [customerProjectAddressOptions, setCustomerProjectAddressOptions] =
    useState([]);
  const [dispatchByOptions, setDispatchByOptions] = useState([]);
  const [deliveredByOptions, setDeliveredByOptions] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    ReportDispatchCustomerIDEncrypt: Yup.string()
      .trim()
      .required("Dispatch Customer is required field"),

    CustomerIDEncrypt: Yup.string()
      .trim()
      .required("Customer is required field"),
    InwardIDEncrypt: Yup.string().trim().required("Inward is required field"),
    ReportDispatchNo: Yup.string()
      .trim()
      .required("Dispatch No is required field"),
    ReportDispatchDate: Yup.string()
      .trim()
      .required("Dispatch Date is required field"),
    CustomerProjectIDEncrypt: Yup.string()
      .trim()
      .required("Project is required field"),
    ReportingToEncrypt: Yup.string()
      .trim()
      .required("Reporting To is required field"),
    CustomerProjectAddressIDEncrypt: Yup.string()
      .trim()
      .required("Address  is required field"),
    DispatchBy: Yup.string().trim().required("Dispatch By is required field"),

    DeliveredByEncrypt: Yup.string().when(
      "DispatchBy",
      ([DispatchBy], schema) => {
        if (DispatchBy == 3)
          return Yup.string().required("Delivered By is required field");
        return schema;
      },
    ),
    CourierIDEncrypt: Yup.string().when(
      "DispatchBy",
      ([DispatchBy], schema) => {
        if (DispatchBy == 4)
          return Yup.string().required("Courier is required field");
        return schema;
      },
    ),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ReportDispatchIDEncrypt: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",
      CustomerIDEncrypt: "",
      ReportDispatchCustomerIDEncrypt: "",
      InwardIDEncrypt: "",
      CustomerName: "",
      InwardNo: "",
      ReportDispatchNo: "",
      ReportDispatchDate: new Date(),
      CustomerProjectIDEncrypt: "",
      CustomerProjectAddressIDEncrypt: "",
      DispatchBy: "",
      ReportingToEncrypt: "",
      DeliveredByEncrypt: "",
      DeliveredTo: "",
      CourierIDEncrypt: "",
      DocketNo: "",
      Remarks: "",
      InwardMaterialIDs: "",
      InwardMaterialIDsEdit: "",
      btnSubmitType: 1,
      ListOfMaterialDetails: [],
      InwardMaterialIDSave: "",
      TCNos: "",
      InwardMaterialIDFinalSave: "",
      InwardDate: "",
      ListOfInwardNoClubing: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      ReportDispatchIDEncrypt,
      CustomerIDEncrypt,
      ReportDispatchCustomerIDEncrypt,
      InwardIDEncrypt,
      ReportDispatchNo,
      ReportDispatchDate,
      CustomerProjectIDEncrypt,
      CustomerProjectAddressIDEncrypt,
      DispatchBy,
      ReportingToEncrypt,
      DeliveredByEncrypt,
      DeliveredTo,
      CourierIDEncrypt,
      DocketNo,
      Remarks,
      InwardMaterialIDs,
      InwardMaterialIDsEdit,
      btnSubmitType,
      ListOfMaterialDetails,
      CustomerName,
      TCNos,
      InwardNo,
      InwardMaterialIDSave,
      InwardMaterialIDFinalSave,
      InwardDate,
      ListOfInwardNoClubing,
    },
  } = formik;

  useEffect(() => {
    if (!ReportDispatchDate) {
      formik.setFieldValue("ReportDispatchDate", "");
    }
  }, [ReportDispatchDate]);

  useEffect(() => {
    if (InwardDate && ReportDispatchDate < InwardDate) {
      formik.setFieldValue("ReportDispatchDate", "");
    }
  }, [InwardDate]);

  const handleValidSubmit = (values) => {
    if (ListOfMaterialDetails?.length == 0) {
      formik.setFieldError(
        "ListOfMaterialDetails",
        "Material Details required!",
      );
      formik.setFieldTouched("ListOfMaterialDetails", true);
      return;
    }

    setIsLoading(true);
    let payload = {
      // ...values,
      ReportDispatchIDEncrypt: values?.ReportDispatchIDEncrypt,
      CustomerIDEncrypt: values?.CustomerIDEncrypt,
      ReportDispatchCustomerIDEncrypt: values?.ReportDispatchCustomerIDEncrypt,
      InwardIDEncrypt: values?.InwardIDEncrypt,
      CustomerProjectIDEncrypt: values?.CustomerProjectIDEncrypt,
      ReportingToEncrypt: values?.ReportingToEncrypt,
      CustomerProjectAddressIDEncrypt: values?.CustomerProjectAddressIDEncrypt,
      DeliveredByEncrypt: values?.DeliveredByEncrypt,
      CourierIDEncrypt: values?.CourierIDEncrypt,
      ReportDispatchNo: values?.ReportDispatchNo,
      DispatchBy: values?.DispatchBy,
      DeliveredTo: values?.DeliveredTo,
      DocketNo: values?.DocketNo,
      InwardMaterialIDs: values?.InwardMaterialIDFinalSave,

      ReportDispatchDate: values?.ReportDispatchDate
        ? moment(values?.ReportDispatchDate)
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")
        : "",

      Remarks: values?.Remarks,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      SendEmailPermissions: AuthUser?.Permissions?.Email,
    };

    post(
      PrimaryIdParam ? POST_UpdateReportDispatch : POST_InsertReportDispatch,
      payload,
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);

          if (btnSubmitType == 2) {
            getReportDispatchPrint(response?.EncryptID);
          }

          setTimeout(() => {
            // navigate("/report-dispatch-list");
            navigate(-1);
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getModeByDDL = () => {
    setDispatchByOptions([
      { value: 1, label: "Email" },
      { value: 2, label: "Post" },
      { value: 3, label: "Hand to Hand" },
      { value: 4, label: "Courier" },
    ]);
  };

  useEffect(() => {
    getCustomerDDL();
    getCourierDDL();
    getModeByDDL();
    getReportDispatchNoDDL();
    getEmployeeDDL();

    if (PrimaryIdParam) {
      GetReportDispatchDetailByID(ReportDispatchIDEncrypt);
    } else {
      if (InwardIDParam) {
        getMaterialInwardDetailByID(InwardIDParam);
      }

      if (InwardMaterialIDParam) {
        formik.setFieldValue("InwardMaterialIDs", [
          {
            value: window.atob(InwardMaterialIDParam),
          },
        ]);

        formik.setFieldValue("InwardMaterialIDsEdit", [
          {
            value: window.atob(InwardMaterialIDParam),
          },
        ]);

        //getMaterialDetails();
      }
    }
  }, []);

  const getMaterialInwardDetailByID = async (id) => {
    setIsLoading(true);
    await post(POST_GetMaterialInwardDetailByID, {
      InwardIDEncrypted: window.atob(id),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue("ReportDispatchDate", new Date());

          formik.setFieldValue("InwardIDEncrypt", response?.InwardIDEncrypted);

          formik.setFieldValue(
            "CustomerIDEncrypt",
            response?.CustomerIDEncrypted,
          );
          formik.setFieldValue(
            "ReportDispatchCustomerIDEncrypt",
            response?.CustomerIDEncrypted,
          );
          formik.setFieldValue(
            "CustomerProjectIDEncrypt",
            response?.CustomerProjectIDEncrypted,
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetReportDispatchDetailByID = async (id) => {
    setIsLoading(true);
    await post(POST_GetReportDispatchDetailByID, {
      ReportDispatchIDEncrypt: id,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ReportDispatchIDEncrypt: response?.ReportDispatchIDEncrypt,
            CustomerIDEncrypt: response?.CustomerIDEncrypt,
            ReportDispatchCustomerIDEncrypt:
              response?.ReportDispatchCustomerIDEncrypt,
            InwardIDEncrypt: response?.InwardIDEncrypt,
            CustomerName: response?.CustomerName,
            InwardNo: response?.InwardNo,
            ReportDispatchNo: response?.ReportDispatchNo,
            ReportDispatchDate: response?.ReportDispatchDate,
            CustomerProjectIDEncrypt: response?.CustomerProjectIDEncrypt,
            CustomerProjectAddressIDEncrypt:
              response?.CustomerProjectAddressIDEncrypt,
            DispatchBy: response?.DispatchBy,
            ReportingToEncrypt: response?.ReportingToEncrypt,
            DeliveredByEncrypt:
              response?.DispatchBy == 3 ? response?.DeliveredByEncrypt : "",
            DeliveredTo: response?.DispatchBy == 3 ? response?.DeliveredTo : "",
            CourierIDEncrypt:
              response?.DispatchBy == 4 ? response?.CourierIDEncrypt : "",
            DocketNo: response?.DispatchBy == 4 ? response?.DocketNo : "",
            Remarks: response?.Remarks,
            InwardMaterialIDSave: response?.InwardMaterialIDs,
            TCNos: response?.TCNos,
            ListOfMaterialDetails: response?.List,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (CustomerIDEncrypt) {
      //getProjectDDL();
      getInwardNoDDL();
      //getTCNoDDL();
    }
  }, [CustomerIDEncrypt]);

  useEffect(() => {
    if (ReportDispatchCustomerIDEncrypt) {
      getProjectDDL();
      setReportingToOptions([]);
      setCustomerProjectAddressOptions([]);
    }
  }, [ReportDispatchCustomerIDEncrypt]);

  useEffect(() => {
    if (InwardIDEncrypt) {
      getTCNoDDL();
    }
  }, [InwardIDEncrypt]);

  useEffect(() => {
    if (CustomerProjectIDEncrypt) {
      getContactPersonDDL();
      getProjectAddressDDL(CustomerProjectIDEncrypt);
    }
  }, [CustomerProjectIDEncrypt]);

  useEffect(() => {
    if (InwardMaterialIDs) {
      getMaterialDetails();
    }
  }, [InwardMaterialIDs]);

  useEffect(() => {
    if (InwardMaterialIDsEdit) {
      getMaterialDetails();
    }
  }, [InwardMaterialIDsEdit]);

  const getContactPersonDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectContactPersonDDLList, {
      CustomerIDEncrypted: ReportDispatchCustomerIDEncrypt,
      CustomerProjectIDEncrypted: CustomerProjectIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setReportingToOptions(
            response?.ContactPersonDDLList?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
            })),
          );

          if (response?.ContactPersonDDLList?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue(
              "ReportingToEncrypt",
              response?.ContactPersonDDLList[0]
                .CustomerContactPersonIDEncrypted,
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getEmployeeDDL = async () => {
    setIsLoading(true);
    await post(POST_GetEmployeeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      UserType: AuthUser?.UserType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDeliveredByOptions(
            response?.EmployeeList?.map((item) => ({
              label: item.EmployeeName,
              value: item.EmployeeIDEncrypted,
            })),
          );
          /*select the value when there is only one option while insert only*/
          if (response?.EmployeeList?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue(
              "DeliveredByEncrypt",
              response?.EmployeeList[0].EmployeeIDEncrypted,
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getReportDispatchNoDDL = async () => {
    setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 8, // 1 = Dispatch Report
      TranDate: ReportDispatchDate
        ? moment(ReportDispatchDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setReportDispatchNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item.VoucherSeries,
              value: item.VoucherSeriesIDEncrypt,
            })),
          );
          if (ReportDispatchNo) {
            if (
              response?.VoucherSeriesList?.filter(
                (x) => x.VoucherSeriesIDEncrypt == ReportDispatchNo,
              )?.length == 0
            ) {
              formik.setFieldValue("ReportDispatchNo", "");
            }
          } else {
            /*select the value when there is only one option while insert only*/
            if (response?.VoucherSeriesList?.length == 1 && !PrimaryIdParam) {
              formik.setFieldValue(
                "ReportDispatchNo",
                response?.VoucherSeriesList[0].VoucherSeriesIDEncrypt,
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      TPIFlag: -1, // -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerList(
            response?.CustomerDDLList?.map((item) => ({
              label: item.CustomerName,
              value: item.CustomerIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProjectAddressDDL = async (projectID) => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectAddressDDLList, {
      CustomerIDEncrypted: ReportDispatchCustomerIDEncrypt,
      CustomerProjectIDEncrypted: projectID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerProjectAddressOptions(
            response?.ProjectAddressDDLList?.map((item) => ({
              label: item.Address,
              value: item.CustomerProjectAddressIDEncrypted,
            })),
          );
          /*select the value when there is only one option while insert only*/
          if (response?.ProjectAddressDDLList?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue(
              `CustomerProjectAddressIDEncrypt`,
              response?.ProjectAddressDDLList[0]
                .CustomerProjectAddressIDEncrypted,
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProjectDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: ReportDispatchCustomerIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCustomerProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            })),
          );

          if (response?.CustomerProjectDDLList?.length == 0) {
            formik.setFieldValue("CustomerProjectIDEncrypt", "");
            setCustomerProjectOptions([]);
          }

          // if (
          //   response?.CustomerProjectDDLList?.length > 0 &&
          //   CustomerProjectIDEncrypt &&
          //   response?.CustomerProjectDDLList?.filter(
          //     (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypt
          //   ).length == 0
          // ) {
          //   alert(1);
          //   formik.setFieldValue("CustomerProjectIDEncrypt", "");
          //   setCustomerProjectOptions([]);
          // }
          // if (
          //   response?.CustomerProjectDDLList?.length == 1 &&
          //   !PrimaryIdParam
          // ) {
          //   formik.setFieldValue(
          //     `CustomerProjectIDEncrypt`,
          //     response?.CustomerProjectDDLList[0].CustomerProjectIDEncrypt
          //   );
          // }
        } else {
          formik.setFieldValue("CustomerProjectIDEncrypt", "");
          setCustomerProjectOptions([]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getInwardNoDDL = async () => {
    setIsLoading(true);
    await post(POST_DDLGetInwardsNoByCustomerID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CustomerIDEncrypted: CustomerIDEncrypt,
      IsMaterialReturnable: -1,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setInwardNoOptions(
            response?.List?.map((item) => ({
              label: item.InwardNo,
              value: item.InwardIDEncrypted,
              CustomerProjectID: item?.CustomerProjectIDEncrypted,
              CustomerProjectAddressID: item?.CustomerProjectAddressIDEncrypted,
              CustomerContactPersonID: item?.CustomerContactPersonIDEncrypted,
              InwardDate: new Date(item.InwardDate),
              IsInwardNoClubing: item?.IsInwardNoClubing,
              InwardClubingNo: item?.InwardClubingNo,
            })),
          );

          if (InwardIDParam) {
            if (
              response?.List?.filter(
                (x) => x.InwardIDEncrypted == window.atob(InwardIDParam),
              )?.length == 0
            ) {
              formik.setFieldValue("InwardIDEncrypt", "");
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTCNoDDL = async () => {
    setIsLoading(true);
    await post(POST_GetReportDispatchTCNoDDLList, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      InwardIDEncrypt: InwardIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTCNosOptionsOptions(
            response?.List?.map((item) => ({
              label: item.TCNo,
              value: item.InwardMaterialIDEncrypt,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCourierDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCourierDDLList, {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setCourierList(
            response?.List?.map((item) => ({
              label: item.CourierName,
              value: item.CourierIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getMaterialDetails = async () => {
    //setIsLoading(true);
    let InwardMaterialIDsFinal = "";
    let InwardMaterialIDsEditFinal = "";

    InwardMaterialIDsEditFinal = Array.from(
      InwardMaterialIDsEdit,
      (x) => x.value,
    ).join(",");

    if (PrimaryIdParam) {
      InwardMaterialIDsFinal =
        InwardMaterialIDSave + "," + InwardMaterialIDsEditFinal;
    } else {
      // if (InwardMaterialIDParam) {
      //   InwardMaterialIDsFinal = window.atob(InwardMaterialIDParam);
      // } else {
      InwardMaterialIDsFinal = Array.from(
        InwardMaterialIDs,
        (x) => x.value,
      ).join(",");
      //}
    }

    setIsLoading(true);
    await post(POST_GetReportDispatchTestNameByInwardMaterialID, {
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      InwardMaterialIDs: InwardMaterialIDsFinal,
      TransactionType: 8, //Dispatch Report
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue("ListOfMaterialDetails", response?.List);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    formik.setFieldValue("InwardMaterialIDFinalSave", InwardMaterialIDsFinal);
  };

  const getReportDispatchPrint = async (id) => {
    setIsLoading(true);
    let payload = {
      ReportDispatchIDEncrypt: id,
    };
    post(POST_ReportDispatchPrint, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showInwardNoClubingModal, setShowInwardNoClubingModal] =
    useState(false);

  const GetInwardNoClubingList = async (inwardID) => {
    setIsLoading(true);
    setShowInwardNoClubingModal(true);

    await post(POST_GetReportDispatchInwardNoClubing, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CustomerIDEncrypt: CustomerIDEncrypt,
      InwardClubingNo: inwardID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfInwardNoClubing",
            response?.ListOfInwardNo,
          );
        } else {
          formik.setFieldValue("ListOfInwardNoClubing", []);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} Report Dispatch
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={3}>
                    {ReportDispatchIDEncrypt ? (
                      <Field
                        label="Dispatch Date"
                        name="ReportDispatchDate"
                        component={CustomInput}
                        disabled={true}
                      />
                    ) : (
                      <Field
                        label="Dispatch Date"
                        name="ReportDispatchDate"
                        placeholder={"Select Dispatch Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          minDate: InwardDate ? InwardDate : "",
                        }}
                        required
                        autoFocus
                      />
                    )}
                  </Col>

                  <Col lg={3}>
                    {ReportDispatchIDEncrypt ? (
                      <Field
                        label="Dispatch No"
                        name="ReportDispatchNo"
                        component={CustomInput}
                        disabled={true}
                      />
                    ) : (
                      <Field
                        label="Dispatch No"
                        name="ReportDispatchNo"
                        placeholder={"Select Dispatch No"}
                        options={reportDispatchNoOptions}
                        component={CustomSelect}
                        required
                      />
                    )}
                  </Col>

                  <Col lg={3}>
                    {ReportDispatchIDEncrypt ? (
                      <Field
                        label="Customer"
                        name="CustomerName"
                        component={CustomInput}
                        disabled={true}
                      />
                    ) : (
                      <Field
                        label="Customer"
                        name="CustomerIDEncrypt"
                        placeholder={"Select Customer"}
                        options={customerOptions}
                        component={CustomSelect}
                        isClearable={false}
                        onChange={(e) => {
                          formik.setFieldValue(
                            `CustomerIDEncrypt`,
                            e?.value ?? "",
                          );
                          formik.setFieldValue(
                            `ReportDispatchCustomerIDEncrypt`,
                            e?.value ?? "",
                          );

                          formik.setFieldValue(`InwardIDEncrypt`, "");
                          formik.setFieldValue(`CustomerProjectIDEncrypt`, "");
                          formik.setFieldValue(
                            `CustomerProjectAddressIDEncrypt`,
                            "",
                          );
                          formik.setFieldValue(`ReportingToEncrypt`, "");
                          formik.setFieldValue(`InwardDate`, "");
                        }}
                        required
                      />
                    )}
                  </Col>
                  <Col lg={3}>
                    {ReportDispatchIDEncrypt ? (
                      <Field
                        label="Inward No"
                        name="InwardNo"
                        component={CustomInput}
                        disabled={true}
                      />
                    ) : (
                      <Field
                        label="Inward No"
                        name="InwardIDEncrypt"
                        placeholder={"Select Inward No"}
                        options={inwardNoOptions}
                        component={CustomSelect}
                        isClearable={false}
                        required
                        onChange={(e) => {
                          getProjectAddressDDL(e?.CustomerProjectID ?? "");

                          formik.setFieldValue(
                            `CustomerProjectIDEncrypt`,
                            e?.CustomerProjectID ?? "",
                          );
                          formik.setFieldValue(
                            `InwardIDEncrypt`,
                            e?.value ?? "",
                          );
                          formik.setFieldValue(
                            `InwardDate`,
                            e?.InwardDate ?? "",
                          );

                          formik.setFieldValue(
                            `CustomerProjectAddressIDEncrypt`,
                            e?.CustomerProjectAddressID ?? "",
                          );
                          formik.setFieldValue(
                            `ReportingToEncrypt`,
                            e?.CustomerContactPersonID ?? "",
                          );

                          if (e?.IsInwardNoClubing == true) {
                            GetInwardNoClubingList(e?.InwardClubingNo ?? "");
                          }
                        }}
                      />
                    )}
                  </Col>
                </Row>
                {TCNos ? (
                  <Row>
                    <Col lg={6}>
                      <Field
                        label="TC No"
                        name="TCNos"
                        component={CustomInput}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <div className="d-flex justify-content-between mb-0">
                    <div className="d-flex mb-0">
                      <label> Report Dispatch</label>
                    </div>
                  </div>
                  <Col lg={6}>
                    <div className="card mb-2" style={{ height: "auto" }}>
                      <div className="card-body p-2">
                        <Row>
                          <Col lg={12}>
                            <div className="col-xl-12 col-lg-12">
                              <div className="row">
                                <Col lg={6}>
                                  <Field
                                    label="Dispatch Customer"
                                    name="ReportDispatchCustomerIDEncrypt"
                                    placeholder={"Select Customer"}
                                    options={customerOptions}
                                    component={CustomSelect}
                                    isClearable={false}
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        `ReportDispatchCustomerIDEncrypt`,
                                        e?.value ?? "",
                                      );
                                      formik.setFieldValue(
                                        `ReportingToEncrypt`,
                                        "",
                                      );
                                      formik.setFieldValue(
                                        `CustomerProjectAddressIDEncrypt`,
                                        "",
                                      );
                                    }}
                                    required
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="Project"
                                    name="CustomerProjectIDEncrypt"
                                    placeholder={"Select Project"}
                                    options={customerProjectOptions}
                                    component={CustomSelect}
                                    isClearable={false}
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        `CustomerProjectIDEncrypt`,
                                        e?.value ?? "",
                                      );

                                      getProjectAddressDDL(e?.value ?? "");
                                    }}
                                    required
                                  />
                                </Col>
                              </div>
                              <div className="row">
                                <Col lg={6}>
                                  <Field
                                    label="Reporting To"
                                    name="ReportingToEncrypt"
                                    placeholder={"Select Reporting To"}
                                    options={reportingToOptions}
                                    component={CustomSelect}
                                    isClearable={false}
                                    required
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="Address"
                                    name="CustomerProjectAddressIDEncrypt"
                                    placeholder={"Select Address"}
                                    options={customerProjectAddressOptions}
                                    component={CustomSelect}
                                    isClearable={false}
                                    required
                                  />
                                </Col>
                              </div>
                              <div className="row">
                                <Col lg={6}>
                                  <Field
                                    label="Dispatch By"
                                    name="DispatchBy"
                                    placeholder={"Select Dispatch Type"}
                                    options={dispatchByOptions}
                                    component={CustomSelect}
                                    isClearable={false}
                                    required
                                  />
                                </Col>
                                <Col lg={6}>
                                  <Field
                                    label="Remarks"
                                    name="Remarks"
                                    rows={2}
                                    placeholder={"Enter Remarks"}
                                    component={CustomTextArea}
                                    maxLength={500}
                                  />
                                </Col>
                              </div>
                              {DispatchBy == 3 ? (
                                <div className="row">
                                  <Col lg={6}>
                                    <Field
                                      label="Delivered By"
                                      name="DeliveredByEncrypt"
                                      placeholder={"Select Delivered By"}
                                      options={deliveredByOptions}
                                      component={CustomSelect}
                                      isClearable={false}
                                      required
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      label="Delivered To"
                                      name="DeliveredTo"
                                      placeholder={"Enter Delivered To"}
                                      component={CustomInput}
                                      maxLength={100}
                                    />
                                  </Col>
                                </div>
                              ) : (
                                ""
                              )}
                              {DispatchBy == 4 ? (
                                <div className="row">
                                  <Col lg={6}>
                                    <Field
                                      label="Courier"
                                      name="CourierIDEncrypt"
                                      placeholder={"Select Courier"}
                                      options={courierOptions}
                                      component={CustomSelect}
                                      isClearable={false}
                                      required
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Field
                                      label="Docket No"
                                      name="DocketNo"
                                      placeholder={"Enter Docket No"}
                                      component={CustomInput}
                                      maxLength={100}
                                    />
                                  </Col>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <Row>
                      <Col lg={12}>
                        <div
                          className="card mb-2"
                          // style={{ maxHeight: "400px", minHeight: "400px" }}
                          style={{ maxHeight: "400px", height: "auto" }}
                        >
                          <div className="card-body p-2">
                            <Row>
                              <Col lg={12}>
                                <div className="row">
                                  <Col lg={12}>
                                    {PrimaryIdParam ? (
                                      // <Field
                                      //   label="TC No"
                                      //   name="InwardMaterialIDsEdit"
                                      //   placeholder={"Select TC No"}
                                      //   options={tCNosOptions}
                                      //   component={CustomMultiSelect}
                                      //   isMulti={true}
                                      //   menuPosition="fixed"
                                      //   // onChange={(e) => {
                                      //   //   getMaterialDetails(e?.value ?? "");
                                      //   // }}
                                      // />
                                      ""
                                    ) : (
                                      <>
                                        <Field
                                          label="TC No"
                                          name="InwardMaterialIDs"
                                          placeholder={"Select TC No"}
                                          options={tCNosOptions}
                                          component={CustomMultiSelect}
                                          isMulti={true}
                                          menuPosition="fixed"
                                          // onChange={(e) => {
                                          //   getMaterialDetails(e?.value ?? "");
                                          // }}
                                        />
                                        <hr className="mt-0 mb-1"></hr>
                                      </>
                                    )}
                                  </Col>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={12}>
                                <div className="d-flex justify-content-between mb-0">
                                  <div className="d-flex mb-0">
                                    <label>Material Details</label>
                                  </div>
                                </div>
                                <hr className="mt-0 mb-1"></hr>
                                <div className="row">
                                  <div className="table-responsive active-projects style-1 shorting mb-2">
                                    <div
                                      id="Materialdetail-tbl_wrapper"
                                      className="dataTables_wrapper no-footer"
                                      style={{
                                        maxHeight: "200px",
                                        overflow: "auto",
                                      }}
                                    >
                                      <table
                                        id="Materialdetail-tbl"
                                        className="table dataTable no-footer mb-0"
                                      >
                                        <thead>
                                          <tr>
                                            <th width="5%"></th>
                                            <th width="30%">TC No</th>
                                            <th width="35%">Sample Name</th>
                                            <th
                                              width="30%"
                                              style={{ textAlign: "left" }}
                                            >
                                              Tests
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {ListOfMaterialDetails?.length > 0 ? (
                                            ListOfMaterialDetails?.map(
                                              (item, indx) => (
                                                <tr>
                                                  <td
                                                    style={{
                                                      whiteSpace: "normal",
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    {indx + 1}
                                                  </td>
                                                  <td
                                                    style={{
                                                      whiteSpace: "normal",
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    {item.TCNo}{" "}
                                                    {item?.IsHold == true && (
                                                      <>
                                                        <b>[Hold]</b>
                                                        <OverlayTrigger
                                                          trigger={[
                                                            "hover",
                                                            "focus",
                                                          ]}
                                                          key={indx}
                                                          responsive={true}
                                                          overlay={
                                                            <Tooltip className="toltip-popover">
                                                              <strong className="p-1">
                                                                <label>
                                                                  Hold:
                                                                </label>{" "}
                                                                {
                                                                  item?.HoldReason
                                                                }
                                                              </strong>
                                                            </Tooltip>
                                                          }
                                                        >
                                                          <span>
                                                            <i
                                                              className="fa fa-info-circle ms-2"
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                color:
                                                                  "#9698ab",
                                                              }}
                                                            ></i>
                                                          </span>
                                                        </OverlayTrigger>
                                                      </>
                                                    )}
                                                  </td>
                                                  <td
                                                    style={{
                                                      whiteSpace: "normal",
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    {item.SampleDetail}
                                                  </td>
                                                  <td
                                                    style={{
                                                      textAlign: "left",
                                                      whiteSpace: "normal",
                                                      verticalAlign: "top",
                                                    }}
                                                  >
                                                    {item.TestNames}
                                                  </td>
                                                </tr>
                                              ),
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={4}
                                                style={{ textAlign: "left" }}
                                              >
                                                <div>
                                                  {"No Record Found..."}
                                                </div>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                      <ErrorMessage
                                        name={"ListOfMaterialDetails"}
                                        component="div"
                                        className="invalid-feedback animated fadeInUp"
                                        style={{ display: "block" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/* <hr className="mt-0 mb-1"></hr> */}
                <div className="stickyBottomButtons">
                  <hr className="mt-0 mb-2"></hr>
                  <button
                    type="submit"
                    // className="btn btn-primary"
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => {
                      formik.setFieldValue("btnSubmitType", 1);
                    }}
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="submit"
                    // className="btn btn-primary"
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => {
                      formik.setFieldValue("btnSubmitType", 2);
                    }}
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit & Print
                  </button>
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showInwardNoClubingModal}
          onHide={setShowInwardNoClubingModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <Modal.Header>
              <Modal.Title>Clubing Inward No </Modal.Title>
              <Button
                type="button"
                variant=""
                className="btn-close"
                onClick={() => setShowInwardNoClubingModal(false)}
              ></Button>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className="mb-1">
                    <span style={{ color: "red" }}>Note : </span>
                    <label>
                      Selected inward is clubbed with other inwards for
                      dispatching report together.
                    </label>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <div className="table-responsive active-projects style-1 shorting mb-2">
                    <div
                      id="Clubing-tbl_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        id="Clubing-tbl"
                        className="table dataTable no-footer mb-0"
                      >
                        <thead>
                          <tr>
                            <th width="5%">Sr No</th>
                            <th width="25%">Inward No</th>
                            <th width="20%">Inward Date</th>
                            <th width="30%">Project Name</th>
                            <th width="20%" style={{ textAlign: "left" }}>
                              Letter Ref No
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ListOfInwardNoClubing?.length > 0 ? (
                            ListOfInwardNoClubing?.map((item, indx) => (
                              <tr key={indx}>
                                <td>{indx + 1}</td>
                                <td>{item.InwardNo}</td>
                                <td>{item.InwardDate}</td>
                                <td>{item.ProjectName}</td>
                                <td style={{ textAlign: "left" }}>
                                  {item.LetterRefNo}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={5} style={{ textAlign: "left" }}>
                                <div>{"No Record Found..."}</div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary btn-sm"
                onClick={() => setShowInwardNoClubingModal(false)}
              >
                OK
              </Button>
            </Modal.Footer>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default AddReportDispatch;
